<template>
  <div id="header">
    <container>
      <grid direction="stack" class="text-center">
        <grid-item style="padding-bottom: 4em;padding-top: 5em;">
          <img
            src="../../../public/img/logos/sg_logo_fulltext_alpha.png"
            class="img-responsive"
            style="max-width: 700px"
          />
        </grid-item>
        <grid-item>
          <p>
            The Open Alpha of Survivor GameZ has ended, and the game mode is no
            longer publicly available.<br />
            We won't see Survivor GameZ itself in the near future, although some
            elements may appear in some of our games.
          </p>
        </grid-item>
        <!--                <grid-item class="xs-hidden">-->
        <!--                    <div style="max-width: 550px;margin: 0 auto">-->
        <!--                        <sgz-button style="font-size: 30px;width: 100%"/>-->
        <!--                    </div>-->
        <!--                </grid-item>-->
        <!--                <grid-item style="padding-top: 2em;text-align: left;" id="sgz-desc">-->
        <!--                    <ul style="padding-left: 0;list-style: none">-->
        <!--                        <li><img src="/fonts/icons/sgz_bullet.svg" class="sgz-bullet"> Use DayZ launcher to turn on Survivor GameZ</li>-->
        <!--                        <li><img src="/fonts/icons/sgz_bullet.svg" class="sgz-bullet"> Enable Battleye</li>-->
        <!--                        <li><img src="/fonts/icons/sgz_bullet.svg" class="sgz-bullet"> Disable all mods and run parameters</li>-->
        <!--                    </ul>-->
        <!--                    <p>-->
        <!--                        Survivor GameZ is a battle royale survival game,<br>-->
        <!--                        which can be played solo or in duo co-op.<br>-->
        <!--                        Join the closed Alpha now!-->
        <!--                    </p>-->
        <!--                </grid-item>-->
      </grid>
    </container>
  </div>
</template>

<script>
import SgzButton from "./Button";

export default {
  name: "SgzHeader",
  components: {
    SgzButton
  }
};
</script>

<style lang="scss" scoped>
#header {
  padding-top: 5em;
  min-height: 600px;
  position: relative;
  z-index: 1;
}

#sgz-desc {
  max-width: 550px;
  margin: 0 auto;
  font-size: 16px;
  letter-spacing: 1.28px;
  line-height: 24px;

  @media (max-width: 500px) {
    letter-spacing: 0;
    font-size: 14px;
  }
}
</style>
